/**
 * Auto generated import statements, do not modify this file manually
 */

export { default as default } from './default.json';

export { default as de } from './de.json';
